<template>
  <div class="AppTreeSelect">
    <el-select
        :popper-append-to-body="false"
        :collapse-tags="!edit"
        :disabled="edit"
        v-model="tagValueIdList"
        multiple
        style="width: 100%"
    >
      <el-option
          v-for="item in selectArr"
          :key="item.id"
          :label="item.name"
          :value="item.id"
          style="display: none"
      ></el-option>
      <el-tree
          ref="areaTrees"
          :props="props"
          :data="treeArr"
          node-key="id"
          show-checkbox
          :default-checked-keys="tagValueIdList"
          :default-expanded-keys="treeArr.length > 0 ? [treeArr[0].id] : []"
          :check-on-click-node="true"
          :expand-on-click-node="false"
          @check="handleCheck"
      ></el-tree>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "AppTreeSelect",
  props: {
    options: {
      type: Array,
      default: () => [],
    },
    valueArr: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      selectArr: [],
      treeArr: [],
      props: {
        label: "name",
        children: "children",
        disabled: function (data) {
          return !data.tagCategoryId && !data.children;
        },
      },
      tagValueIdList: [1, 2, 3],
      treeIdList: [],
    };
  },
  watch: {
    options: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.treeArr = newVal;
          this.selectArr = this.filterArr(newVal);
        }
      },
      immediate: true,
    },
    valueArr: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.tagValueIdList = newVal;
        }
      },
      immediate: true,
    },
    tagValueIdList: {
      handler: function (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$nextTick(() => {
            this.$refs.areaTrees.setCheckedKeys(newVal);
          });
          this.$emit("tagChange", newVal);
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleCheck(val, checked) {
      let arr = [];
      if (checked.checkedNodes.length > 0) {
        // 将checkedKeys中的父级id过滤出去
        arr = checked.checkedKeys.filter((id) => {
          return !checked.checkedNodes.some(
              (item) => item.children && item.id === id
          );
        });
      } else {
        arr = checked.checkedKeys;
      }
      this.tagValueIdList = arr;
      this.$emit("check", val, checked);
    },
    //把有children的数据过滤出来组成新的数组
    filterArr(arr) {
      let newArr = [];
      arr.forEach((item) => {
        if (item.children) {
          newArr.push(...item.children);
        } else {
          newArr.push(item);
        }
      });
      return newArr;
    },
    //   移除tag
    // handleDeleteTag(val) {
    //   console.log(val);
    //   console.log(this.tagValueIdList);
    // },
  },
};
</script>

<style lang="scss" scoped>
.AppTreeSelect {
  ::v-deep .el-select-dropdown__wrap {
    max-height: 500px !important;
  }
}
</style>
